<template>
  <div class="mail">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" :class="{'select':statusType=='ing'}" @click="toggleType('ing')">待处理</div>
      <div class="robbing-nav-item" :class="{'select':statusType=='complete'}" @click="toggleType('complete')">已出库</div>
      <div class="robbing-nav-item" :class="{'select':statusType=='cancel'}" @click="toggleType('cancel')">已取消</div>
    </nav>
    <div class="empty-data" v-if="!haveData">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无数据</p>
      </div>
    </div>
    <div class="mail-go-item" v-for="item in sendList" :key="item._id">
      <div class="mail-item-top">
        <div class="mail-item-top-left">
          <p class="expressCompany">
            {{item.expressCompany?item.expressCompany.name:'待分配快递'}}
            <span style="position: relative; top: -4px;">{{item.status}}</span>
          </p>
          <p class="weight">
            {{item.expressNo?("物流单号："+item.expressNo):'待分配物流单号'}} &nbsp;&nbsp;
            <i class="iconfont icon-fuzhi" v-if="item.expressNo" v-clipboard:copy="item.expressNo" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError"></i>
          </p>
          <section class="mail-tips" v-if="!item.paotui && item.status=='待件到站' && !item.freight">
            <p style="font-size:12px;">请您把待寄物品送到快递服务中心，工作人员核价后您就可以看到支付运费按钮啦。</p>
          </section>
        </div>
        <div class="mail-item-top-right">
          <img :src="'data:image/png;base64,'+item.qrimgBase64" @click="showImagePreview('data:image/png;base64,'+item.qrimgBase64)">
        </div>
      </div>
      <div class="mainInfo">
        <div class="mail-item">
          <div class="mail-item-left">
            <span class="iconfont icon-ji jijian"></span>
          </div>
          <div class="mail-item-middle">
            <p>
              <span class="mail-user">{{item.sender}}</span>
              <span>{{item.senderPhone}}</span>
            </p>
            <p class="address">{{item.senderAddress}}</p>
          </div>
        </div>
        <div class="mail-to mail-item">
          <div class="mail-item-left">
            <span class="iconfont icon-shou shoujian"></span>
          </div>
          <div class="mail-item-middle">
            <p>
              <span class="mail-user">{{item.receiver}}</span>
              <span>{{item.receiverPhone}}</span>
            </p>
            <p class="address">{{item.receiverAddress}}</p>
          </div>
        </div>
        <div class="weui-cell" v-if="item.paotui">
          <div class="weui-cell__bd">
            <p>跑腿单号</p>
          </div>
          <div class="weui-cell__ft">{{item.paotui.orderNo}}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>待寄物品</p>
          </div>
          <div class="weui-cell__ft">{{item.goodsName}} x{{item.goodsCount?item.goodsCount:1}}</div>
        </div>
        <div class="weui-cell" v-if="item.insureMoney">
          <div class="weui-cell__bd">
            <p>保价金额
              <span style="font-size: 12px; color: gold;">（保价费：{{item.insureFreight}} 元）</span>
            </p>
          </div>
          <div class="weui-cell__ft">{{item.insureMoney}} 元</div>
        </div>
        <div class="weui-cell" v-if="item.remark">
          <div class="weui-cell__bd">
            <p>寄件备注</p>
          </div>
          <div class="weui-cell__ft">{{item.remark}}</div>
        </div>
        <div class="weui-cell" v-if="item.paotui && item.paotui.acceptUser">
          <div class="weui-cell__bd">
            <p>校内跑腿</p>
          </div>
          <div class="weui-cell__ft">
            {{item.paotui.acceptUser}}
            <a :href="'tel:'+item.paotui.acceptUserPhone" style="color: blue; border: none; margin-left: 0px; padding: 0;">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>订单费用</p>
          </div>
          <div class="weui-cell__ft">
            <span v-if="!item.isDaofu">运：{{item.freight?item.freight/100 : '待定'}}</span>
            <span v-if="item.isDaofu">运：到付</span>
            <span v-if="item.paotui">, 赏：{{item.paotui.fee / 100}}元</span>
          </div>
        </div>
        <div class="weui-cell" v-if="item.status!='已出库'&&item.status!='已取消'">
          <div class="weui-cell__bd">
            <p>支付状态</p>
          </div>
          <div class="weui-cell__ft">
            <span v-if="item.isDaofu">运费到付</span>
            <span v-if="!item.isDaofu">运费{{item.freightPay?'已付':'未付'}}</span>
            <span v-if="item.paotui">, 跑腿{{item.paotui.isPayed?'已付':'未付'}}</span>
          </div>
        </div>
      </div>
      <div class="collgoods-item-bottom" v-if="!item.paotui && item.status=='待分配单号'">
        <div class="collgoods-item-bottom-right">
          <a href="javascript:;" style="border: none; background-color: orangered; color: #fff;" @click="deleteById(item._id)">关闭</a>
        </div>
      </div>
      <div class="collgoods-item-bottom" v-else-if="item.status!='待分配单号' && item.status!='待出库' && item.status!='已出库' && item.status!='已取消'">
        <div class="collgoods-item-bottom-right" v-if="item.status == '待支付'">
          <a href="javascript:;" style="border: none; background-color: orangered; color: #fff;" @click="deleteById(item._id)">关闭</a>
          <a href="javascript:;" style="border: none; background-color: #1aad19; color: #fff;" @click="goPay(item)">预付赏金</a>
        </div>
        <div class="collgoods-item-bottom-right" v-if="item.status == '已发任务'">
          <a href="javascript:;" style="border: none; background-color: orangered; color: #fff;" @click="deleteById(item._id)">关闭</a>
        </div>
        <div class="collgoods-item-bottom-right" v-if="item.status == '已领任务'">
          <a href="javascript:;" style="border: none; background-color: #1aad19; color: #fff;" @click="qujian(item)">跑腿已取件</a>
        </div>
        <div class="collgoods-item-bottom-right" v-if="item.status == '待核算运费'">
          <a href="javascript:;" style="border: none; background-color: grey; color: #fff;">支付运费</a>
        </div>
        <div class="collgoods-item-bottom-right" v-if="item.status == '待付运费' || item.status == '待件到站'">
          <a href="javascript:;" style="border: none; background-color: orangered; color: #fff;" v-if="!item.paotui" @click="deleteById(item._id)">关闭</a>
          <a href="javascript:;" style="border: none; background-color: #1aad19; color: #fff;" v-if="item.freight && !item.freightPay && !item.isDaofu" @click="payFreight(item)">支付运费</a>
        </div>
      </div>
    </div>

    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>
<script>
import config from "../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      haveData: true,
      statusType: "",
      year: moment().format("YYYY"),
      sendList: [],
      imgs: []
    };
  },
  created() {
    let that = this;
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });

    this.statusType = this.$route.params.status;
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 获取用户信息，socket 监听openid 对应的消息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let openid = response.data.data.openid;
        const socket = io(config.socket, {
          transports: ["websocket"]
        });
        // 建立 socket 连接
        socket.on("connect", function() {
          console.log("socket.io connect...");
        });
        socket.on('reconnect_attempt', () => {
          socket.io.opts.transports = ['websocket', 'polling'];
        });
        socket.on(openid + "-freightUpdate", function(item) {
          // 更新对应ID的寄件信息
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == item._id) {
              that.sendList[i].freight = item.freight;
              that.sendList[i].status = "待付运费";
              that.sendList[i].expressCompany = {
                name: item.expressCompany.name
              };
              that.sendList[i].prepayId = item.prepayId;

              // 弹出支付框
              that.payFreight(that.sendList[i]);
              break;
            }
          }
          that.sendList = [...that.sendList];
        });
        socket.on("freightPaySuccessDaofu", function(item) {
          // 更新对应ID的寄件信息
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == item._id) {
              that.sendList[i].freight = 0;
              that.sendList[i].isDaofu = true;
              that.sendList[i].status = "待分配单号";
              that.sendList[i].expressCompany = {
                name: item.expressCompanyName
              };
              break;
            }
          }
          that.sendList = [...that.sendList];
        });
        socket.on("expressTakeinArrived", function(item) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == item._id) {
              that.sendList[i].status = "待出库";
              that.sendList[i].expressNo = item.expressNo;
              break;
            }
          }
        });
        socket.on("paotuiOrderRobbinged", function(item) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == item._id) {
              that.sendList[i].status = "已领任务";
              that.sendList[i].paotui = item.paotui;
              break;
            }
          }
        });
        socket.on("paotuiOrderCancel", function(_id) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == _id) {
              that.sendList[i].status = "待分配单号";
              that.sendList[i].paotui = {};
              break;
            }
          }
        });
        socket.on("paotuiHaveGettedExpress", function(_id) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == _id) {
              that.sendList[i].status = "待跑腿确认";
              break;
            }
          }
        });
        socket.on("paotuiConfirmHaveGettedExpress", function(_id) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == _id) {
              that.sendList[i].status = "待核算运费";
              break;
            }
          }
        });
        socket.on("paotuiOrderCancelToWait", function(_id) {
          for (let i = 0; i < that.sendList.length; i++) {
            if (that.sendList[i]._id == _id) {
              that.sendList[i].status = "已发任务";
              delete that.sendList[i].paotui.acceptUser;
              break;
            }
          }
        });
        /**
         * 快递已经寄出
         * 如果是在进行中标签页，则需要删除该数据
         * 如果是在已完成页签，则需要新增一条记录
         */
        socket.on("expressTotakeinSended", function(item) {
          if (that.statusType == "ing") {
            for (let i = 0; i < that.sendList.length; i++) {
              if (that.sendList[i]._id == item._id) {
                that.sendList.splice(i, 1);
                break;
              }
            }
            if (that.sendList.length == 0) {
              that.haveData = false;
            }
          } else if (that.statusType == "complete") {
            item.status = "已出库";
            that.sendList.unshift(item);
            that.haveData = true;
          }
        });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });

    // 获取列表
    axios
      .get("/api/expressTakein/wxlist/" + this.statusType)
      .then(response => {
        loading.hide(function() {});
        if (response.data.success) {
          this.sendList = response.data.data;
          if (this.sendList.length == 0) {
            this.haveData = false;
          }
          for (let i = 0; i < this.sendList.length; i++) {
            if (this.sendList[i].status == 0) {
              this.sendList[i].status = "待支付";
            } else if (this.sendList[i].status == 1) {
              this.sendList[i].status = "已发任务";
            } else if (this.sendList[i].status == 2) {
              this.sendList[i].status = "已领任务";
            } else if (this.sendList[i].status == 3) {
              this.sendList[i].status = "待跑腿确认";
            } else if (this.sendList[i].status == 4) {
              this.sendList[i].status = "待分配单号";
            } else if (this.sendList[i].status == 5) {
              this.sendList[i].status = "待出库";
            } else if (that.sendList[i].status == 10) {
              that.sendList[i].status = "待核算运费";
            } else if (that.sendList[i].status == 20) {
              that.sendList[i].status = "待付运费";
            } else if (this.sendList[i].status == 100) {
              this.sendList[i].status = "已出库";
            } else if (this.sendList[i].status == 400) {
              this.sendList[i].status = "已取消";
            }

            if (this.sendList[i].insureMoney) {
              this.sendList[i].insureFreight = Math.ceil(
                this.sendList[i].insureMoney * config.insurePercent / 100
              );
            }
          }
        } else {
          loading.hide(function() {});
          this.haveData = false;
          weui.topTips("获取寄件列表失败", 2000);
        }
      })
      .catch(error => {
        loading.hide(function() {});
        this.haveData = false;
        weui.topTips("获取寄件列表失败", 2000);
      });
  },
  methods: {
    toggleType(type) {
      if (this.statusType != type) {
        this.statusType = type;
        let loading = weui.loading("数据加载中", {
          className: "custom-classname"
        });

        axios
          .get("/api/expressTakein/wxlist/" + this.statusType)
          .then(response => {
            loading.hide(function() {});
            if (response.data.success) {
              this.sendList = response.data.data;
              console.log(this.sendList);
              if (this.sendList.length == 0) {
                this.haveData = false;
              } else {
                this.haveData = true;
              }
              for (let i = 0; i < this.sendList.length; i++) {
                if (this.sendList[i].status == 0) {
                  this.sendList[i].status = "待支付";
                } else if (this.sendList[i].status == 1) {
                  this.sendList[i].status = "已发任务";
                } else if (this.sendList[i].status == 2) {
                  this.sendList[i].status = "已领任务";
                } else if (this.sendList[i].status == 3) {
                  this.sendList[i].status = "待跑腿确认";
                } else if (this.sendList[i].status == 4) {
                  this.sendList[i].status = "待分配单号";
                } else if (this.sendList[i].status == 5) {
                  this.sendList[i].status = "待出库";
                } else if (this.sendList[i].status == 10) {
                  this.sendList[i].status = "待核算运费";
                } else if (this.sendList[i].status == 20) {
                  this.sendList[i].status = "待付运费";
                } else if (this.sendList[i].status == 100) {
                  this.sendList[i].status = "已出库";
                } else if (this.sendList[i].status == 400) {
                  this.sendList[i].status = "已取消";
                }

                if (this.sendList[i].insureMoney) {
                  this.sendList[i].insureFreight = Math.ceil(
                    this.sendList[i].insureMoney * config.insurePercent / 100
                  );
                }
              }
            } else {
              loading.hide(function() {});
              this.haveData = false;
              weui.alert("获取寄件列表失败");
            }
          })
          .catch(error => {
            console.log(error);
            loading.hide(function() {});
            this.haveData = false;
            weui.alert("获取寄件列表失败");
          });
      }
    },
    onCopySuccess() {
      weui.toast("复制成功", 1000);
    },
    onCopyError() {
      weui.toast("暂不支持复制功能", 1000);
    },
    showImagePreview(img) {
      this.imgs = [img];
      this.$createImagePreview({
        imgs: this.imgs
      }).show();
    },
    payFreight(item) {
      let that = this;
      // 获取支付签名
      let params = {
        package: item.prepayId
      };

      axios
        .get("/api/wx/paysign", { params })
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function(res) {
              // 直接改变当前item的状态为待接单
              item.freightPay = true;
              // 如果挂了跑腿
              item.status = "待分配单号";
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    },
    goPay(item) {
      let that = this;
      // 获取支付签名
      let params = {
        package: item.paotui.prepayId
      };

      axios
        .get("/api/wx/paysign", { params })
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function(res) {
              // 直接改变当前item的状态为待接单
              item.status = 1;
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    },
    deleteById(id) {
      let that = this;
      weui.confirm(
        "确定取关闭寄件单？",
        function() {
          axios
            .delete("/api/expressTakein/" + id)
            .then(res => {
              if (res.data.success) {
                weui.toast("关闭成功", 1000);
                // 从列表中删除对应的记录
                for (let i = 0; i < that.sendList.length; i++) {
                  if (that.sendList[i]._id == id) {
                    that.sendList.splice(i, 1);
                    if (that.sendList.length == 0) {
                      that.haveData = false;
                    }
                    break;
                  }
                }
              } else {
                setTimeout(function() {
                  weui.alert("关闭失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function() {
                weui.alert("关闭失败");
              }, 500);
            });
        },
        function() {}
      );
    },
    qujian(item) {
      let that = this;
      weui.confirm(
        "确定快递已被跑腿取走？",
        function() {
          axios
            .put("/api/paotuiOrder/paotuiTakeaway/" + item.paotui._id)
            .then(res => {
              if (res.data.success) {
                weui.toast("已取件成功", 1000);
              } else {
                setTimeout(function() {
                  weui.alert("已取件失败");
                }, 500);
              }
            })
            .catch(err => {
              setTimeout(function() {
                weui.alert("已取件失败");
              }, 500);
            });
        },
        function() {}
      );
    }
  }
};
</script>
<style scoped>
.mail {
  margin: 0 auto;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
.mail-go-item {
  margin-top: 10px;
  border: 1px solid #1aad19;
  margin: 15px;
}
.mail-item {
  display: flex;
  align-items: center;
  padding: 8px 0px;
}
.mainInfo {
  margin-left: 10px;
  margin-right: 10px;
}
.mail-item + .mail-item {
  border-top: 1px solid #eee;
}
.mail-item-left {
  width: 60px;
  text-align: center;
}
.mail-item-left span {
  padding: 10px;
  border-radius: 100%;
}
.jijianLogo {
  font-size: 16px;
  background-color: #1aad19;
}
.shoujianLogo {
  font-size: 16px;
  background-color: red;
}
.mail-item-middle {
  flex: 1;
  text-align: left;
  font-size: 14px;
}
.mail-item-middle .address {
  margin-right: 10px;
}
.mail-user {
  font-size: 18px;
  font-weight: bold;
}
.mail-item-right {
  width: 40px;
}
.mail-setmsg {
  border: 1px solid #eee;
  margin-top: 10px;
}
.mail-setmsg-item {
  text-align: left;
}
.mail-setmsg-item.top,
.mail-setmsg-item.middle {
  line-height: 40px;
  height: 40px;
  border-bottom: 1px solid #eee;
  padding-left: 5px;
}
.mail-setmsg-item.middle {
  display: flex;
}
.middle-left {
  width: 120px;
}
.middle-right {
  flex: 1;
  text-align: right;
}
.mail-setmsg-item.bottom {
  display: flex;
  min-height: 80px;
  align-items: center;
}
.bottom-remark-left {
  width: 50px;
  line-height: 80px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  text-align: center;
}
.bottom-remark-right {
  padding-left: 0px;
  flex: 1;
  padding: 5px 0px;
}
.bottom-remark-right textarea {
  display: block;
  width: 100%;
  height: 80px;
  border: 0px;
}
.mail-submit {
  display: block;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  color: white;
  background-color: rgb(299 28 35);
  margin-top: 20px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.mail-item-top {
  display: flex;
  border-bottom: 1px solid #eee;
  padding: 10px 5px;
}
.mail-item-top-left {
  margin-left: 10px;
}
.mail-item-top-left .expressCompany {
  font-size: 20px;
  font-weight: bold;
  color: orange;
}
.mail-item-top-left .expressCompany span {
  background-color: orangered;
  font-size: 12px;
  color: #fff;
  padding: 4px;
  border-radius: 4px;
}
.mail-item-top-left .weight {
  color: steelblue;
  font-size: 16px;
  font-weight: bold;
}
.mail-item-top-right {
  flex: 1;
  text-align: right;
  margin-right: 15px;
}
.mail-item-top-right img {
  width: 60px;
  height: 60px;
  position: absolute;
  right: 25px;
}
.collgoods-item-bottom {
  display: flex;
  min-height: 40px;
  line-height: 40px;
  border-top: 1px solid #eee;
  font-size: 15px;
}
.collgoods-item-bottom > div {
  flex: 1;
}
.collgoods-item-bottom-left {
  padding-left: 10px;
  text-align: left;
  color: orangered;
}
.collgoods-item-bottom-left span {
  font-weight: bold;
}
.collgoods-item-bottom-right {
  text-align: right;
  margin-right: 10px;
}
.collgoods-item-bottom a {
  display: inline;
  padding: 4px 10px;
  margin-left: 10px;
  border-radius: 5px;
  border: 1px solid orangered;
  color: orangered;
  font-size: 14px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.weui-cell {
  font-size: 16px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.freight-bnt {
  background-color: gold;
  padding: 4px;
  font-size: 14px;
  border-radius: 100%;
  color: #fff;
}
.jijian {
  color: #1aad19;
  font-size: 3rem;
}
.shoujian {
  color: red;
  font-size: 3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/ExpressSendList.vue